import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { InputHTMLAttributes } from 'react';

export interface ICustomTextField
  extends InputHTMLAttributes<HTMLInputElement> {
  prevObject?: React.ReactNode;
  prevIcon?: IconDefinition;
  postIcon?: IconDefinition;
  placeholder?: string;
  defaultValue?: string;
  className?: string;
  onIconClick?: () => void;
  inputRef?: React.RefObject<HTMLInputElement | null>;
  textareaRef?: React.RefObject<HTMLTextAreaElement | null>;
  isTextarea?: boolean;
  borderRadius?: EBorderRadius;
  darker?: boolean;
  error?: string;
  small?: boolean;
}

export enum EBorderRadius {
  DEFAULT = 'default',
  ROUNDED = 'rounded',
  SQUARE = 'square',
}
